// Which colour palette the site uses.
//
// Every colour in the stylesheets is a --vv-* token defined in theme.css, so
// the whole site switches palette from this one setting:
//   "ink"      Ink & court green. The live palette.
//   "daylight" Daylight Court: white, court blue and lime. Saved for later.
//
// To switch the live site, change ACTIVE_PALETTE and deploy.
// To preview the other palette without deploying, add ?palette=daylight to
// any URL (or ?palette=ink to go back). The preview lasts for that visit only.
export const PALETTES = ["ink", "daylight"];
export const ACTIVE_PALETTE = "ink";

// Browser bar colour for each palette, so mobile chrome matches the header.
const THEME_COLOR = { ink: "#12140F", daylight: "#FFFFFF" };

export function applyPalette() {
  let palette = ACTIVE_PALETTE;
  try {
    const asked = new URLSearchParams(window.location.search).get("palette");
    if (PALETTES.includes(asked)) {
      sessionStorage.setItem("vv-palette", asked);
    }
    const saved = sessionStorage.getItem("vv-palette");
    if (PALETTES.includes(saved)) palette = saved;
  } catch (e) {
    /* storage can be blocked; the active palette still applies */
  }
  document.documentElement.setAttribute("data-vv-palette", palette);
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", THEME_COLOR[palette]);
}
